export const HTML_BLOGS = {
  "india-oci-rule-change-may-2026-nri-property": `
    <style>
        /* ── Reset & Variables ── */
        .raw-html-blog *,
        .raw-html-blog *::before,
        .raw-html-blog *::after {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }

        .raw-html-blog {
            --ink: #1C1F28;
            --ink-soft: #64748B;
            --accent: #C9A84C;
            /* warm terracotta — India-inspired */
            --accent-2: #b78800;
            /* gold */
            --surface: #F7F9FC;
            /* warm white */
            --card: #ffffff;
            --rule: rgba(201, 168, 76, 0.25);
            --tag-bg: rgba(201, 168, 76, 0.08);

            --max-w: 780px;
            --serif: 'Playfair Display', Georgia, serif;
            --sans: 'DM Sans', system-ui, sans-serif;

            background: var(--surface);
            color: var(--ink);
            font-family: var(--sans);
            font-size: 17px;
            line-height: 1.75;
            -webkit-font-smoothing: antialiased;
        }

        /* ── Layout ── */
        .raw-html-blog .page-wrap {
            max-width: var(--max-w);
            margin: 0 auto;
            padding: 0 24px 80px;
        }

        /* ── Top bar ── */
        .raw-html-blog .top-bar {
            background: var(--ink);
            color: #fff;
            text-align: center;
            font-size: 12px;
            letter-spacing: .08em;
            text-transform: uppercase;
            padding: 10px 16px;
        }

        .raw-html-blog .top-bar a {
            color: var(--accent-2);
            text-decoration: none;
        }

        /* ── Hero ── */
        .raw-html-blog .hero {
            padding: 24px 24px 0;
            max-width: var(--max-w);
            margin: 0 auto;
        }

        .raw-html-blog .category-tag {
            display: inline-block;
            background: var(--accent);
            color: #fff;
            font-size: 11px;
            font-weight: 600;
            letter-spacing: .1em;
            text-transform: uppercase;
            padding: 4px 12px;
            border-radius: 2px;
            margin-bottom: 20px;
        }

        .raw-html-blog h1 {
            font-family: var(--serif);
            font-size: clamp(28px, 5vw, 42px);
            line-height: 1.2;
            color: var(--ink);
            margin-bottom: 20px;
            max-width: 680px;
        }

        .raw-html-blog .hero-deck {
            font-size: 18px;
            color: var(--ink-soft);
            max-width: 640px;
            margin-bottom: 28px;
            line-height: 1.65;
        }

        .raw-html-blog .meta-row {
            display: flex;
            align-items: center;
            gap: 20px;
            font-size: 13px;
            color: var(--ink-soft);
            border-top: 1px solid var(--rule);
            border-bottom: 1px solid var(--rule);
            padding: 12px 0;
            margin-bottom: 48px;
            flex-wrap: wrap;
        }

        .raw-html-blog .meta-row strong {
            color: var(--ink);
        }

        .raw-html-blog .meta-dot {
            opacity: .35;
        }

        /* ── Alert box ── */
        .raw-html-blog .alert {
            background: var(--tag-bg);
            border-left: 4px solid var(--accent);
            border-radius: 4px;
            padding: 18px 22px;
            margin: 32px 0;
            font-size: 15.5px;
        }

        .raw-html-blog .alert strong {
            color: var(--accent);
        }

        /* ── Body content ── */
        .raw-html-blog .body-content {
            margin-top: 0;
        }

        .raw-html-blog h2 {
            font-family: var(--serif);
            font-size: clamp(20px, 3.5vw, 26px);
            color: var(--ink);
            margin: 52px 0 16px;
            padding-top: 8px;
        }

        .raw-html-blog h3 {
            font-size: 17px;
            font-weight: 600;
            color: var(--ink);
            margin: 28px 0 10px;
        }

        .raw-html-blog p {
            margin-bottom: 20px;
        }

        .raw-html-blog a {
            color: var(--accent);
            text-decoration-thickness: 1px;
        }

        .raw-html-blog a:hover {
            text-decoration: none;
        }

        /* ── Quick-reference cards ── */
        .raw-html-blog .cards-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 16px;
            margin: 28px 0 36px;
        }

        .raw-html-blog .card {
            background: var(--card);
            border: 1px solid var(--rule);
            border-radius: 8px;
            padding: 20px;
        }

        .raw-html-blog .card-label {
            font-size: 11px;
            font-weight: 600;
            letter-spacing: .08em;
            text-transform: uppercase;
            color: var(--ink-soft);
            margin-bottom: 6px;
        }

        .raw-html-blog .card-value {
            font-family: var(--serif);
            font-size: 22px;
            color: var(--ink);
            margin-bottom: 4px;
        }

        .raw-html-blog .card-note {
            font-size: 13px;
            color: var(--ink-soft);
        }

        /* ── Fee table ── */
        .raw-html-blog .fee-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 15px;
            margin: 20px 0 32px;
        }

        .raw-html-blog .fee-table thead {
            background: var(--ink);
            color: #fff;
        }

        .raw-html-blog .fee-table th {
            padding: 12px 16px;
            text-align: left;
            font-weight: 500;
            font-size: 13px;
            letter-spacing: .04em;
        }

        .raw-html-blog .fee-table td {
            padding: 12px 16px;
            border-bottom: 1px solid var(--rule);
            vertical-align: top;
        }

        .raw-html-blog .fee-table tbody tr:last-child td {
            border-bottom: none;
        }

        .raw-html-blog .fee-table tbody tr:hover {
            background: var(--tag-bg);
        }

        /* ── Checklist ── */
        .raw-html-blog .checklist {
            list-style: none;
            margin: 16px 0 28px;
        }

        .raw-html-blog .checklist li {
            padding: 10px 0 10px 36px;
            position: relative;
            border-bottom: 1px solid var(--rule);
            font-size: 15.5px;
        }

        .raw-html-blog .checklist li:last-child {
            border-bottom: none;
        }

        .raw-html-blog .checklist li::before {
            content: "✓";
            position: absolute;
            left: 8px;
            top: 10px;
            font-weight: 700;
            color: #2e7d32;
            font-size: 14px;
        }

        .raw-html-blog .checklist li.no::before {
            content: "✕";
            color: var(--accent);
        }

        /* ── Pull quote ── */
        .raw-html-blog .pull-quote {
            border-left: 3px solid var(--accent-2);
            padding: 12px 24px;
            margin: 36px 0;
            font-family: var(--serif);
            font-size: 19px;
            color: var(--ink);
            line-height: 1.5;
            font-style: italic;
        }

        /* ── Divider ── */
        .raw-html-blog hr.section-break {
            border: none;
            border-top: 1px solid var(--rule);
            margin: 44px 0;
        }

        /* ── FAQ section ── */
        .raw-html-blog .faq-item {
            border-bottom: 1px solid var(--rule);
            padding: 20px 0;
        }

        .raw-html-blog .faq-q {
            font-weight: 600;
            font-size: 16px;
            color: var(--ink);
            margin-bottom: 10px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 12px;
        }

        .raw-html-blog .faq-q::after {
            content: "+";
            font-size: 22px;
            font-weight: 300;
            color: var(--accent);
            flex-shrink: 0;
            margin-top: -2px;
        }

        .raw-html-blog details[open] .faq-q::after {
            content: "−";
        }

        .raw-html-blog .faq-a {
            font-size: 15.5px;
            color: var(--ink-soft);
            line-height: 1.7;
            padding-top: 8px;
        }

        /* ── CTA band ── */
        .raw-html-blog .cta-band {
            background: var(--ink);
            color: #fff;
            border-radius: 10px;
            padding: 36px 32px;
            margin: 52px 0 0;
            text-align: center;
        }

        .raw-html-blog .cta-band h3 {
            font-family: var(--serif);
            font-size: 22px;
            color: #fff;
            margin: 0 0 10px;
        }

        .raw-html-blog .cta-band p {
            color: rgba(255, 255, 255, .7);
            font-size: 15px;
            margin-bottom: 22px;
        }

        .raw-html-blog .cta-btn {
            display: inline-block;
            background: var(--accent);
            color: #fff;
            font-weight: 600;
            font-size: 15px;
            padding: 14px 32px;
            border-radius: 4px;
            text-decoration: none;
            transition: background .2s;
        }

        .raw-html-blog .cta-btn:hover {
            background: #a83828;
            color: #fff;
        }

        /* ── Breadcrumb ── */
        .raw-html-blog .breadcrumb {
            font-size: 13px;
            color: var(--ink-soft);
            padding: 20px 24px 0;
            max-width: var(--max-w);
            margin: 0 auto;
        }

        .raw-html-blog .breadcrumb a {
            color: var(--ink-soft);
            text-decoration: none;
        }

        .raw-html-blog .breadcrumb a:hover {
            color: var(--accent);
        }

        .raw-html-blog .breadcrumb span {
            margin: 0 6px;
            opacity: .4;
        }

        /* ── Responsive ── */
        @media (max-width: 600px) {
            .raw-html-blog .fee-table {
                font-size: 13px;
            }

            .raw-html-blog .fee-table th,
            .raw-html-blog .fee-table td {
                padding: 10px 10px;
            }

            .raw-html-blog h1 {
                font-size: 26px;
            }
        }
    </style>

    <!-- ═══ BODY ═══ -->
    <main class="page-wrap">
        <article class="body-content" itemscope itemtype="https://schema.org/Article">

            <!-- Quick facts -->
            <div class="alert">
                <strong>Bottom line for property buyers:</strong> Your right to purchase residential and commercial
                property in India as an OCI holder has <em>not changed</em>. What has changed is how you maintain your
                OCI status and what happens if you don't comply. Read on for the full picture.
            </div>

            <!-- Stat cards -->
            <div class="cards-grid" aria-label="Key changes at a glance">
                <div class="card">
                    <div class="card-label">Effective date</div>
                    <div class="card-value">1 May 2026</div>
                    <div class="card-note">Citizenship (Amendment) Rules, 2026 notified April 30</div>
                </div>
                <div class="card">
                    <div class="card-label">Processing time</div>
                    <div class="card-value">&lt; 15 days</div>
                    <div class="card-note">Down from the previous 6–8 weeks under paper-based system</div>
                </div>
                <div class="card">
                    <div class="card-label">Passport update window</div>
                    <div class="card-value">3 months</div>
                    <div class="card-note">Or face a ~USD 25 fine and potential entry issues</div>
                </div>
                <div class="card">
                    <div class="card-label">Fresh OCI fee</div>
                    <div class="card-value">~$315</div>
                    <div class="card-note">₹22,500 from India · ~£210 from the UK</div>
                </div>
            </div>

            <!-- ── Section 1 ── -->
            <h2>What Are the Citizenship (Amendment) Rules, 2026?</h2>
            <p>
                India's Ministry of Home Affairs (MHA) formally notified the <strong>Citizenship (Amendment) Rules,
                    2026</strong> on April 30, 2026, replacing key parts of the Citizenship Rules, 2009. This is the
                most far-reaching reform to the OCI framework since the programme launched in 2005. The revision is
                built on two central themes: <strong>full digitisation</strong> of the OCI lifecycle, and
                <strong>stricter compliance obligations</strong> for existing cardholders.
            </p>
            <p>
                The OCI scheme — a lifelong, multipurpose, multiple-entry travel document — allows foreign citizens of
                Indian origin to live, work, and invest in India indefinitely. It is <em>not</em> dual citizenship. OCI
                holders cannot vote, hold most government posts, or purchase agricultural land. What they can do — and
                this remains unchanged — is buy residential and commercial property freely, without needing RBI
                permission.
            </p>

            <!-- ── Section 2 ── -->
            <h2>The 7 Key Changes Explained</h2>

            <h3>1. Everything moves online — no more paper or postal submissions</h3>
            <p>
                The headline change is the launch of a fully digital portal at <strong>ociservices.gov.in</strong>. All
                applications for registration, re-issuance, renunciation, and appeals must now be submitted online.
                Offline walk-in and postal submissions are no longer accepted anywhere in the world. For NRIs in the US,
                UK, UAE, Australia, or anywhere else — this means the Indian consulate no longer accepts physical
                applications.
            </p>

            <h3>2. Physical card is now optional — e-OCI introduced</h3>
            <p>
                Applicants can now choose between a physical OCI card, an electronic e-OCI record, or both. The e-OCI is
                tied to a central electronic registry that border officials and Indian missions can verify in real time.
                This also integrates with the Fast Track Immigration Programme at 24 major Indian airports. Processing
                is expected to take under 15 working days — a significant improvement over the previous 6 to 8 week
                timeline.
            </p>

            <h3>3. Mandatory passport update within 3 months — or face a fine</h3>
            <p>
                Existing OCI holders who get a new passport must now update their details on the OCI portal
                <strong>within three months</strong> of the new passport being issued. Failure to do so attracts a
                penalty of approximately <strong>USD 25</strong> (or equivalent). More critically, failure to update can
                render an e-OCI invalid at the immigration counter — which could mean being denied entry to India.
            </p>

            <div class="pull-quote">
                "If you renewed your passport in the last six months and haven't updated your OCI portal record — do it
                now. This is the single most time-sensitive compliance task the new rules create for most OCI holders."
            </div>

            <h3>4. Six-month residency requirement removed</h3>
            <p>
                Under the old rules, eligible foreign nationals who were already in India had to complete six months of
                stay before applying for OCI from within the country. That requirement has been scrapped. Anyone with a
                valid long-term visa and the required documents can apply via the FRRO soon after arrival — reducing
                administrative delays for those already in India.
            </p>

            <h3>5. Stricter rules for minors with dual passports</h3>
            <p>
                Perhaps the most consequential change for diaspora families: minors can no longer hold both an Indian
                and a foreign passport simultaneously. Parents applying for an Indian passport for a child must sign a
                declaration that no foreign passport exists or will be obtained. Children with an existing foreign
                passport must surrender it before an Indian passport is issued. This affects thousands of families
                across the Gulf, North America, the UK, and Australia.
            </p>

            <h3>6. Spouse-based OCI gets a probationary period</h3>
            <p>
                OCI cards granted on the basis of marriage now have an initial validity of <strong>five years</strong>,
                extendable to a lifetime status only after verification that the marriage remains valid. The intent is
                to deter sham marriages used to obtain Indian residency rights.
            </p>

            <h3>7. Broader eligibility for Sri Lankan Tamils</h3>
            <p>
                The eligibility window for Sri Lankan Tamils of Indian origin has been extended from fourth-generation
                descendants to fifth and sixth generations — opening OCI access to a significantly larger community.
            </p>

            <!-- ── Section 3 ── -->
            <hr class="section-break" />
            <h2>Updated OCI Fee Schedule (May 2026)</h2>
            <p>The following fees are drawn from the official MHA notification. Currency conversions are approximate.
            </p>

            <table class="fee-table" aria-label="OCI fees under the 2026 rules">
                <thead>
                    <tr>
                        <th>Application Type</th>
                        <th>India (₹)</th>
                        <th>USD</th>
                        <th>GBP (approx.)</th>
                        <th>AED (approx.)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Fresh OCI registration</td>
                        <td>₹22,500</td>
                        <td>~$315</td>
                        <td>~£210</td>
                        <td>~AED 1,160</td>
                    </tr>
                    <tr>
                        <td>Re-issuance (passport renewal)</td>
                        <td>₹8,900</td>
                        <td>~$125</td>
                        <td>~£85</td>
                        <td>~AED 460</td>
                    </tr>
                    <tr>
                        <td>Duplicate card (lost/damaged)</td>
                        <td>—</td>
                        <td>~$100</td>
                        <td>~£75</td>
                        <td>—</td>
                    </tr>
                    <tr>
                        <td>Passport non-update penalty</td>
                        <td>—</td>
                        <td>~$25</td>
                        <td>~£20</td>
                        <td>—</td>
                    </tr>
                </tbody>
            </table>
            <p style="font-size:13px; color:var(--ink-soft); margin-top:-16px;">Source: MHA Citizenship (Amendment)
                Rules, 2026. Verify exact figures at ociservices.gov.in before applying.</p>

            <!-- ── Section 4 ── -->
            <hr class="section-break" />
            <h2>What Hasn't Changed: Property Rights for NRIs and OCI Holders</h2>
            <p>
                The May 2026 amendments deal entirely with the OCI <em>application and compliance framework</em> — not
                with property rights. Here is a clear summary of what was already the law and remains the law:
            </p>

            <ul class="checklist" aria-label="OCI property rights">
                <li>OCI holders can buy <strong>residential property</strong> in India — any number, no RBI permission
                    needed</li>
                <li>OCI holders can buy <strong>commercial property</strong> in India — same general permission applies
                </li>
                <li>OCI holders can inherit agricultural land and retain it</li>
                <li>Transactions must still comply with <strong>FEMA regulations</strong></li>
                <li>Sale proceeds can be repatriated subject to RBI limits</li>
                <li>TDS deduction rules apply to property transactions involving NRI/OCI sellers</li>
                <li class="no">OCI holders <strong>cannot purchase</strong> agricultural land, plantation property, or
                    farmhouses directly</li>
                <li class="no">OCI holders <strong>cannot vote</strong> or hold most constitutional posts</li>
                <li class="no">PIO cards are <strong>no longer valid</strong> — former PIO holders must apply for OCI
                </li>
            </ul>

            <p>
                One important simplification introduced in Budget 2026, separate from the OCI amendments: from
                <strong>October 1, 2026</strong>, the TAN (Tax Deduction Account Number) requirement for buyers
                purchasing from NRI or OCI sellers will be removed. Buyers will be able to use their existing PAN to
                deduct tax, making transactions significantly smoother and reducing the buyer's reluctance to engage
                with NRI-owned properties.
            </p>

            <!-- ── Section 5 ── -->
            <hr class="section-break" />
            <h2>Travel Obligations: The New e-Arrival Card</h2>
            <p>
                Separate from the OCI amendments but equally relevant: all international travellers to India — including
                OCI holders and NRIs — must now complete a <strong>mandatory digital e-Arrival Card</strong> at least 72
                hours before boarding their flight. Physical disembarkation forms have been permanently discontinued at
                all Indian airports.
            </p>
            <p>
                The form is available at <a href="https://arrivals.mha.gov.in" target="_blank"
                    rel="noopener">arrivals.mha.gov.in</a> and takes approximately five minutes to complete. It asks for
                flight number, arrival date, accommodation address in India, and passport or OCI details. Arriving
                without completing it can cause delays at immigration. Keep a digital confirmation ready.
            </p>

            <!-- ── Section 6 ── -->
            <hr class="section-break" />
            <h2>Your Action Checklist: What to Do Right Now</h2>

            <ul class="checklist" aria-label="Action checklist for OCI holders">
                <li>If you renewed your passport in the last 3 months — <strong>update your OCI portal record
                        immediately</strong> at ociservices.gov.in</li>
                <li>If you have a minor child holding both an Indian and foreign passport — <strong>seek legal
                        advice</strong> on compliance with the new dual-passport prohibition</li>
                <li>If you hold a PIO card — it is now invalid. <strong>Apply for OCI afresh</strong> via the digital
                    portal</li>
                <li>If you obtained OCI through marriage — check your card's expiry; <strong>apply for lifetime
                        extension</strong> if the initial five-year period has passed and your marriage is intact</li>
                <li>Before travelling to India — complete the <strong>e-Arrival Card</strong> at arrivals.mha.gov.in at
                    least 72 hours before departure</li>
                <li>If you are planning to sell Indian property — <strong>note the TAN removal effective October 1,
                        2026</strong>, which will simplify the process</li>
            </ul>

            <!-- ── FAQ ── -->
            <hr class="section-break" />
            <h2>Frequently Asked Questions</h2>

            <div itemscope itemtype="https://schema.org/FAQPage">

                <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <summary class="faq-q" itemprop="name">Can I still buy property in India on my OCI card after May
                        2026?</summary>
                    <div class="faq-a" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                        <p itemprop="text">Yes, absolutely. Your property rights as an OCI holder have not changed. You
                            can purchase residential or commercial property in India without needing RBI permission.
                            What changed is how you maintain your OCI status, not what you can do with it.</p>
                    </div>
                </details>

                <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <summary class="faq-q" itemprop="name">I am an NRI with an Indian passport — do these OCI rules
                        apply to me?</summary>
                    <div class="faq-a" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                        <p itemprop="text">Not directly. OCI is a status for foreign citizens of Indian origin — not
                            Indian passport holders. As an NRI you already hold an Indian passport and travel on that.
                            However, the e-Arrival Card requirement applies to all international travellers including
                            NRIs.</p>
                    </div>
                </details>

                <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <summary class="faq-q" itemprop="name">Is the PIO card still accepted at Indian airports?</summary>
                    <div class="faq-a" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                        <p itemprop="text">No. The PIO card conversion window closed in December 2025 and PIO cards are
                            no longer valid for travel to India. If you are a former PIO card holder, you must apply for
                            OCI registration afresh through ociservices.gov.in.</p>
                    </div>
                </details>

                <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <summary class="faq-q" itemprop="name">What is the penalty for not updating my passport details on
                        the OCI portal?</summary>
                    <div class="faq-a" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                        <p itemprop="text">A fine of approximately USD 25 (or local currency equivalent). More
                            seriously, failure to update can make your e-OCI invalid at the immigration counter,
                            potentially resulting in denial of entry or delays at the airport. The update must be done
                            within three months of your new passport being issued.</p>
                    </div>
                </details>

                <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <summary class="faq-q" itemprop="name">How long does an OCI application take now?</summary>
                    <div class="faq-a" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                        <p itemprop="text">Under the new digital system, the government estimates processing in under 15
                            working days — significantly faster than the previous 6 to 8 week timeline under the
                            paper-based system.</p>
                    </div>
                </details>

                <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <summary class="faq-q" itemprop="name">Can a non-resident spouse (non-NRI, non-OCI) buy property in
                        India?</summary>
                    <div class="faq-a" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                        <p itemprop="text">A non-resident spouse who is not an NRI or OCI can acquire one property in
                            India for residence purposes, subject to the condition that the marriage has been registered
                            for at least two years. This rule predates the May 2026 changes and has not been altered.
                        </p>
                    </div>
                </details>

            </div><!-- /FAQPage -->

            <!-- ── Disclaimer ── -->
            <hr class="section-break" />
            <p style="font-size:13.5px; color:var(--ink-soft); line-height:1.65;">
                <strong>Disclaimer:</strong> This article is for informational purposes only and does not constitute
                legal, tax, or financial advice. OCI and immigration regulations are subject to change. Verify all
                details with a qualified legal professional or directly via official government portals before taking
                any action. All fees and timelines are approximate and subject to official notification.
            </p>

            <!-- ── CTA ── -->
            <div class="cta-band">
                <h3>Looking to Buy Property in India?</h3>
                <p>Our advisors specialise in NRI and OCI property transactions — from documentation to completion.</p>
                <a href="/contact" class="cta-btn">Speak to a property advisor</a>
            </div>

        </article>
    </main>
  `,
  "dubai-property-investor-visa-2026-new-rules": `<style>
    /* ── Brand tokens ─────────────────────────────────────────── */
    :root {
      --nc-gold:         #E8D49A;
      --nc-gold-light:   #E8D49A;
      --nc-dark:         #0F1117;
      --nc-charcoal:     #1C1F28;
      --nc-mid:          #2B2F3A;
      --nc-text:         #1C1F28;
      --nc-muted:        #9A97A0;
      --nc-border:       rgba(201,168,76,0.18);
      --nc-green:        #3DAA7A;
      --nc-font-display: 'Georgia', 'Times New Roman', serif;
      --nc-font-body:    system-ui, -apple-system, 'Segoe UI', sans-serif;
      --nc-max-w:        780px;
      --nc-radius:       6px;
    }

    /* ── Layout ── */
    .nc-article {
      max-width: var(--nc-max-w);
      margin: 0 auto;
      padding: 60px 24px 80px;
    }

    /* ── Breadcrumb ── */
    .nc-breadcrumb {
      font-size: 12px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: var(--nc-muted);
      margin-bottom: 32px;
    }
    .nc-breadcrumb span { margin: 0 6px; }

    /* ── Tag + date ── */
    .nc-meta-row {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-wrap: wrap;
      margin-bottom: 20px;
    }
    .nc-tag {
      display: inline-block;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: var(--nc-gold);
      border: 1px solid var(--nc-gold);
      border-radius: 2px;
      padding: 3px 10px;
    }
    .nc-tag--new {
      background: var(--nc-gold);
      color: var(--nc-dark);
      border-color: var(--nc-gold);
    }

    /* ── H1 ── */
    h1 {
      font-family: var(--nc-font-display);
      font-size: clamp(26px, 4vw, 42px);
      font-weight: 400;
      line-height: 1.2;
      color: var(--nc-text);
      margin-bottom: 20px;
    }

    /* ── Byline ── */
    .nc-byline {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 13px;
      color: var(--nc-muted);
      padding-bottom: 28px;
      border-bottom: 1px solid var(--nc-border);
      margin-bottom: 40px;
      flex-wrap: wrap;
    }
    .nc-byline strong { color: var(--nc-text); }
    .nc-byline .dot { color: var(--nc-border); }

    /* ── Hero ── */
    .nc-hero {
      width: 100%;
      aspect-ratio: 16/7;
      background: var(--nc-mid);
      border-radius: var(--nc-radius);
      overflow: hidden;
      margin-bottom: 48px;
      position: relative;
    }
    .nc-hero img {
      width: 100%; height: 100%;
      object-fit: cover;
      display: block;
    }
    .nc-hero figcaption {
      position: absolute;
      bottom: 0; left: 0; right: 0;
      background: linear-gradient(transparent, rgba(0,0,0,0.72));
      font-size: 12px;
      color: rgba(255,255,255,0.6);
      padding: 24px 16px 10px;
      text-align: center;
    }

    /* ── Breaking-news banner ── */
    .nc-breaking {
      display: flex;
      align-items: flex-start;
      gap: 14px;
      background: rgba(201,168,76,0.08);
      border: 1px solid var(--nc-gold);
      border-left: 4px solid var(--nc-gold);
      border-radius: var(--nc-radius);
      padding: 16px 20px;
      margin-bottom: 40px;
    }
    .nc-breaking__label {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      color: var(--nc-gold);
      white-space: nowrap;
      margin-top: 2px;
    }
    .nc-breaking__text {
      font-size: 15px;
      color: var(--nc-text);
      line-height: 1.55;
    }

    /* ── Comparison table ── */
    .nc-table-wrap { overflow-x: auto; margin: 40px 0; }
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14.5px;
    }
    thead tr {
      background: var(--nc-mid);
    }
    thead th {
      text-align: left;
      padding: 12px 16px;
      font-weight: 600;
      font-size: 13px;
      letter-spacing: 0.04em;
      color: var(--nc-gold-light);
      border-bottom: 1px solid var(--nc-border);
    }
    tbody tr { border-bottom: 1px solid var(--nc-border); }
    tbody tr:nth-child(even) { background: rgba(255,255,255,0.025); }
    tbody td {
      padding: 12px 16px;
      color: var(--nc-muted);
      vertical-align: top;
    }
    tbody td:first-child {
      color: var(--nc-text);
      font-weight: 500;
    }
    .td-good { color: var(--nc-green); font-weight: 600; }
    .td-gold { color: var(--nc-gold); font-weight: 600; }

    /* ── Prose ── */
    .nc-prose h2 {
      font-family: var(--nc-font-display);
      font-size: clamp(20px, 2.5vw, 26px);
      font-weight: 400;
      color: var(--nc-text);
      margin: 52px 0 16px;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--nc-border);
    }
    .nc-prose h3 {
      font-size: 17px;
      font-weight: 600;
      color: var(--nc-gold-light);
      margin: 32px 0 10px;
    }
    .nc-prose p { margin-bottom: 20px; color: var(--nc-muted); }

    /* ── Pull quote ── */
    .nc-pullquote {
      border-left: 3px solid var(--nc-gold);
      margin: 40px 0;
      padding: 16px 24px;
      background: var(--nc-charcoal);
      border-radius: 0 var(--nc-radius) var(--nc-radius) 0;
      font-family: var(--nc-font-display);
      font-size: 19px;
      font-style: italic;
      color: var(--nc-gold-light);
      line-height: 1.5;
    }

    /* ── Step list ── */
    .nc-steps { margin: 32px 0; counter-reset: step; }
    .nc-step {
      display: flex;
      gap: 20px;
      padding: 20px 0;
      border-bottom: 1px solid var(--nc-border);
    }
    .nc-step:last-child { border-bottom: none; }
    .nc-step__num {
      flex-shrink: 0;
      width: 36px; height: 36px;
      border-radius: 50%;
      background: var(--nc-charcoal);
      border: 1px solid var(--nc-gold);
      display: flex; align-items: center; justify-content: center;
      font-family: var(--nc-font-display);
      font-size: 15px;
      color: var(--nc-gold);
      margin-top: 2px;
    }
    .nc-step__body { flex: 1; }
    .nc-step__title {
      font-weight: 600;
      font-size: 16px;
      color: var(--nc-text);
      margin-bottom: 6px;
    }
    .nc-step__desc { font-size: 14.5px; color: var(--nc-muted); line-height: 1.65; }

    /* ── Callout ── */
    .nc-callout {
      background: var(--nc-charcoal);
      border: 1px solid var(--nc-border);
      border-radius: var(--nc-radius);
      padding: 20px 24px;
      margin: 32px 0;
      font-size: 15px;
      color: var(--nc-muted);
    }
    .nc-callout strong { color: var(--nc-text); }

    /* ── Stat strip ── */
    .nc-stats {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      gap: 1px;
      background: var(--nc-border);
      border: 1px solid var(--nc-border);
      border-radius: var(--nc-radius);
      overflow: hidden;
      margin: 40px 0;
    }
    .nc-stat { background: var(--nc-charcoal); padding: 20px 16px; text-align: center; }
    .nc-stat__num {
      font-family: var(--nc-font-display);
      font-size: 24px;
      color: var(--nc-gold);
      display: block;
      line-height: 1;
      margin-bottom: 6px;
    }
    .nc-stat__label { font-size: 12px; color: var(--nc-muted); line-height: 1.35; }

    /* ── FAQ ── */
    .nc-faq { margin-top: 56px; }
    .nc-faq__title {
      font-family: var(--nc-font-display);
      font-size: 22px;
      font-weight: 400;
      color: var(--nc-text);
      margin-bottom: 24px;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--nc-border);
    }
    .nc-faq__item { border-bottom: 1px solid var(--nc-border); }
    .nc-faq__q {
      width: 100%; background: none; border: none;
      text-align: left;
      color: var(--nc-text);
      font-size: 16px;
      font-family: var(--nc-font-body);
      font-weight: 500;
      padding: 18px 0;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
    }
    .nc-faq__q:hover { color: var(--nc-gold-light); }
    .nc-faq__icon {
      flex-shrink: 0;
      width: 20px; height: 20px;
      color: var(--nc-gold);
      transition: transform 0.25s ease;
    }
    .nc-faq__item.open .nc-faq__icon { transform: rotate(45deg); }
    .nc-faq__a {
      font-size: 15px;
      color: var(--nc-muted);
      line-height: 1.7;
      padding: 0 0 20px;
      display: none;
    }
    .nc-faq__item.open .nc-faq__a { display: block; }

    /* ── CTA ── */
    .nc-cta {
      margin-top: 64px;
      padding: 40px 36px;
      background: linear-gradient(135deg, var(--nc-charcoal) 0%, var(--nc-mid) 100%);
      border: 1px solid var(--nc-gold);
      border-radius: var(--nc-radius);
      text-align: center;
    }
    .nc-cta__eyebrow {
      font-size: 11px;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      color: var(--nc-gold);
      margin-bottom: 12px;
    }
    .nc-cta__heading {
      font-family: var(--nc-font-display);
      font-size: clamp(20px, 3vw, 28px);
      font-weight: 400;
      color: var(--nc-heading);
      margin-bottom: 12px;
    }
    .nc-cta__sub { font-size: 15px; color: var(--nc-muted); margin-bottom: 28px; }
    .nc-cta__btns { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
    .nc-btn {
      display: inline-block;
      padding: 12px 28px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.04em;
      border-radius: 3px;
      text-decoration: none;
      transition: opacity 0.15s;
    }
    .nc-btn:hover { opacity: 0.85; }
    .nc-btn--primary { background: var(--nc-gold); color: var(--nc-dark); }
    .nc-btn--outline { border: 1px solid var(--nc-gold); color: var(--nc-gold); }

    @media (max-width: 600px) {
      .nc-article { padding: 36px 18px 60px; }
      .nc-cta { padding: 28px 20px; }
    }
  </style>
    <div class="nc-prose" itemprop="articleBody">

    <p>For 17 years, a single number blocked tens of thousands of Dubai property buyers from getting residency: AED 750,000. Own a studio in JVC for AED 550,000? No visa. Own a one-bed in Dubai South for AED 480,000? No visa. The property was yours — the residency was not.</p>

    <p>That changed on 1 May 2026. The Dubai Land Department (DLD) confirmed the removal of the minimum property value requirement for sole owners applying for the two-year Property Investor Visa. Any fully paid, completed unit in Dubai now qualifies — regardless of price.</p>

    <p>This is one of the most significant shifts in UAE residency-by-property rules since freehold ownership was introduced in 2002. Here is exactly what changed, who it affects, what it costs, and how it compares to the 10-year Golden Visa.</p>

    <h2>What exactly changed on 1 May 2026</h2>

    <p>The two-year Property Investor Visa was introduced in 2009 with a AED 750,000 minimum property value requirement. The intent was to tie residency to a meaningful capital commitment. In practice, it cut off most mid-market buyers — studio and one-bedroom apartment owners in communities like Jumeirah Village Circle, International City, Dubai Silicon Oasis, and Dubailand routinely fell below the threshold.</p>

    <p>The updated rules, published on the DLD's Cube platform, make the following changes:</p>

    <div class="nc-stats">
      <div class="nc-stat">
        <span class="nc-stat__num">AED 0</span>
        <span class="nc-stat__label">Minimum value for sole owners (was AED 750K)</span>
      </div>
      <div class="nc-stat">
        <span class="nc-stat__num">AED 400K</span>
        <span class="nc-stat__label">Minimum per co-owner for jointly held properties</span>
      </div>
      <div class="nc-stat">
        <span class="nc-stat__num">2 years</span>
        <span class="nc-stat__label">Visa duration — renewable</span>
      </div>
      <div class="nc-stat">
        <span class="nc-stat__num">AED 10,545</span>
        <span class="nc-stat__label">Approximate total visa cost</span>
      </div>
    </div>

    <p>The 10-year Golden Visa pathway is <strong>unchanged</strong>. A minimum property value of AED 2 million remains the qualifying threshold. Nothing in this update affects Golden Visa eligibility.</p>

    <h2>Who this opens the door for</h2>

    <p>The practical impact is largest for three groups of buyers who were previously locked out:</p>

    <h3>Mid-market first-time investors</h3>
    <p>Studios and one-bedroom apartments in high-yield communities — JVC, Arjan, Dubai South, International City, Dubai Silicon Oasis — regularly transact between AED 400,000 and AED 700,000. These buyers were investing in Dubai's market but gaining none of the residency benefit. The rule change gives them a legal right to live where they invest.</p>

    <h3>NRI and South Asian professionals</h3>
    <p>India and Germany consistently rank among the top sources of foreign buyer demand in Dubai. Many Indian buyers in the sub-AED 1 million segment were purchasing purely for yield with no visa pathway. That calculation has now changed. A AED 600,000 apartment in Business Bay that generates 7% annually now comes with a renewable residency option for the entire family.</p>

    <h3>Co-investors and couples</h3>
    <p>The previous rules did not accommodate joint ownership for visa purposes. Now two buyers who jointly own a property each need AED 400,000 in equity — meaning a AED 800,000 unit purchased by two people can generate two independent visa applications. This is a material structural change for investor-couples and business partners.</p>

    <div class="nc-pullquote">
      "The removal of the minimum threshold is a meaningful demand-side catalyst at a critical moment. This policy broadens the buyer pool to absorb incoming supply."
      <br><span style="font-size:14px; font-style:normal; color: var(--nc-muted);">— Pranav Chaudhary, property consultant, quoted in AGBI</span>
    </div>

    <h2>Two-year investor visa vs. Golden Visa: which one is right for you</h2>

    <p>Both visas offer UAE residency through property ownership. They serve different buyer profiles.</p>

    <div class="nc-table-wrap">
      <table>
        <thead>
          <tr>
            <th>Criteria</th>
            <th>2-Year Property Investor Visa</th>
            <th>10-Year Golden Visa</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Min. property value (sole owner)</td>
            <td class="td-good">No minimum</td>
            <td class="td-gold">AED 2,000,000</td>
          </tr>
          <tr>
            <td>Min. property value (co-owner)</td>
            <td class="td-good">AED 400,000 per person</td>
            <td>AED 2,000,000 per applicant</td>
          </tr>
          <tr>
            <td>Visa duration</td>
            <td>2 years, renewable</td>
            <td class="td-gold">10 years, renewable</td>
          </tr>
          <tr>
            <td>Family sponsorship</td>
            <td>Spouse + dependent children</td>
            <td class="td-gold">Spouse, children, parents</td>
          </tr>
          <tr>
            <td>Minimum stay requirement</td>
            <td>None</td>
            <td class="td-gold">None</td>
          </tr>
          <tr>
            <td>Mortgaged property</td>
            <td>Accepted (bank NOC required)</td>
            <td>Accepted (bank NOC required)</td>
          </tr>
          <tr>
            <td>Off-plan property</td>
            <td>Not accepted (ready only)</td>
            <td>Not accepted (ready only)</td>
          </tr>
          <tr>
            <td>Leads to citizenship</td>
            <td>No</td>
            <td>No</td>
          </tr>
          <tr>
            <td>Approx. total cost</td>
            <td>AED 10,545</td>
            <td>AED 10,000–14,000</td>
          </tr>
          <tr>
            <td>Best suited for</td>
            <td>First-time investors, mid-market buyers, sub-AED 2M owners</td>
            <td class="td-gold">Long-term residents, family offices, AED 2M+ investors</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p>The two-year visa is a stepping stone, not a consolation prize. Many investors use it to establish residency while building equity toward the AED 2 million Golden Visa threshold. Nova Capital's advisors can map out that progression based on your current portfolio.</p>

    <h2>Eligibility rules in full</h2>

    <div class="nc-callout">
      <strong>Property must be:</strong> located in Dubai (not other Emirates or DIFC) · a completed unit with a registered DLD title deed · fully paid or mortgaged with a bank NOC · solely or jointly owned per the thresholds above. Off-plan units do not qualify until handover and title registration.
    </div>

    <p>The visa does not impose a minimum stay requirement, which means investors who split time between Dubai and another country can maintain residency without a mandatory annual presence. It does require renewal every two years, and continued property ownership is a condition of renewal.</p>

    <h2>How to apply: the process step by step</h2>

    <div class="nc-steps">
      <div class="nc-step">
        <div class="nc-step__num">1</div>
        <div class="nc-step__body">
          <div class="nc-step__title">Verify title deed registration</div>
          <div class="nc-step__desc">Confirm your property has a completed title deed registered with the Dubai Land Department. Off-plan units do not qualify until handover. If your property is mortgaged, request a No Objection Certificate from your bank.</div>
        </div>
      </div>
      <div class="nc-step">
        <div class="nc-step__num">2</div>
        <div class="nc-step__body">
          <div class="nc-step__title">Apply via the DLD Cube platform</div>
          <div class="nc-step__desc">The application is processed through the DLD's Cube Centre platform. You will need your title deed, passport copy, Emirates ID (if renewing), and bank NOC if applicable. New applicants will need a medical fitness test and Emirates ID biometrics.</div>
        </div>
      </div>
      <div class="nc-step">
        <div class="nc-step__num">3</div>
        <div class="nc-step__body">
          <div class="nc-step__title">Pay fees</div>
          <div class="nc-step__desc">Total cost is approximately AED 10,545, covering visa fees, Emirates ID, and processing charges. Dependent applications carry separate fees but use the principal applicant's property as the qualifying asset.</div>
        </div>
      </div>
      <div class="nc-step">
        <div class="nc-step__num">4</div>
        <div class="nc-step__body">
          <div class="nc-step__title">Receive residency stamp and Emirates ID</div>
          <div class="nc-step__desc">Processing typically takes 5–10 working days. The visa is issued for two years and linked to continued ownership of the qualifying property.</div>
        </div>
      </div>
    </div>

    <h2>What this means for the wider market</h2>

    <p>The timing matters. Dubai had over 50,000 units expected for handover in 2026, and the conflict with Iran created a pause in buyer activity in Q1. The AED 750,000 threshold removal is an explicit demand-side intervention: it widens the buyer pool for exactly the segment — sub-AED 1 million completed units — that needs volume support.</p>

    <p>Analysts note that 24% of 2026 ready-home sales fell below the former AED 750,000 threshold. Every one of those buyers is now eligible for residency for the first time. That is not a marginal adjustment — it is a structural expansion of Dubai's investable buyer base.</p>

    <p>For communities like JVC, Dubai South, International City, and Dubai Silicon Oasis, this policy functions as a price floor. Residency-linked demand has historically proven more durable than pure yield demand during periods of regional uncertainty. Buyers who are committed to a two-year residency period are less likely to exit on short-term sentiment.</p>

    <div class="nc-callout">
      <strong>Nova Capital's view:</strong> The rule change most benefits buyers in the AED 400,000–750,000 range who previously had no residency pathway. If you are in this bracket, the cost-benefit of completing a purchase has materially improved. Properties in this range now carry an additional non-financial yield: legal UAE residency for you and your family.
    </div>

  </div><!-- /nc-prose -->

  `,
  "dubai-investor-visa-2026-no-minimum-property-value": `
   <style>
        /* ── Reset & Variables ── */
        .raw-html-blog *,
        .raw-html-blog *::before,
        .raw-html-blog *::after {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }

        .raw-html-blog {
            --ink: #1C1F28;
            --ink-soft: #64748B;
            --accent: #C9A84C;
            /* warm terracotta — India-inspired */
            --accent-2: #b78800;
            /* gold */
            --surface: #F7F9FC;
            /* warm white */
            --card: #ffffff;
            --rule: rgba(201, 168, 76, 0.25);
            --tag-bg: rgba(201, 168, 76, 0.08);

            --max-w: 780px;
            --serif: 'Playfair Display', Georgia, serif;
            --sans: 'DM Sans', system-ui, sans-serif;

            background: var(--surface);
            color: var(--ink);
            font-family: var(--sans);
            font-size: 17px;
            line-height: 1.75;
            -webkit-font-smoothing: antialiased;
        }

      .topbar {
    background: var(--ink);
    padding: 0 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .topbar-brand { font-family: var(--serif); font-size: 15px; color: var(--gold-light); letter-spacing: .06em; font-style: italic; }
  .topbar-right { display: flex; gap: 8px; align-items: center; }
  .topbar-badge { font-size: 10px; letter-spacing: .08em; text-transform: uppercase; padding: 3px 10px; border-radius: 20px; font-weight: 500; }
  .tb-gold { background: rgba(184,151,58,.2); color: var(--gold-light); border: 1px solid rgba(184,151,58,.3); }
  .tb-green { background: rgba(15,107,58,.3); color: #7DDFB0; border: 1px solid rgba(109,200,160,.3); }

  /* ── HERO ── */
  .hero {
    background: var(--ink);
    padding: 56px 48px 48px;
    position: relative;
    overflow: hidden;
  }
  .hero::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 320px; height: 320px;
    background: radial-gradient(circle, rgba(184,151,58,.12) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }
  .hero-eyebrow { font-size: 10px; letter-spacing: .14em; text-transform: uppercase; color: var(--gold); margin-bottom: 14px; font-weight: 500; }
  .hero-title { font-family: var(--serif); font-size: 32px; color: var(--white); line-height: 1.2; font-weight: 500; max-width: 640px; margin-bottom: 16px; }
  .hero-title em { color: var(--gold-light); font-style: italic; }
  .hero-sub { font-size: 13px; color: rgba(255,255,255,.55); max-width: 500px; line-height: 1.7; margin-bottom: 24px; }
  .hero-chips { display: flex; gap: 8px; flex-wrap: wrap; }
  .chip { display: inline-flex; align-items: center; gap: 5px; padding: 4px 12px; border-radius: 20px; font-size: 11px; font-weight: 500; }
  .chip-gold { background: rgba(184,151,58,.18); color: var(--gold-light); border: 1px solid rgba(184,151,58,.3); }
  .chip-green { background: rgba(15,107,58,.3); color: #7DDFB0; border: 1px solid rgba(109,200,160,.3); }
  .chip-blue { background: rgba(24,56,160,.3); color: #A0B4F0; border: 1px solid rgba(154,170,224,.3); }
  .chip-white { background: rgba(255,255,255,.08); color: rgba(255,255,255,.6); border: 1px solid rgba(255,255,255,.12); }

  /* ── LAYOUT ── */
  .section-head {
    display: flex; align-items: flex-start; gap: 14px;
    padding-bottom: 16px; margin-bottom: 22px;
    border-bottom: 1px solid var(--border);
  }
  .snum {
    min-width: 30px; height: 30px;
    background: var(--ink); color: var(--gold-light);
    border-radius: 50%; display: flex; align-items: center; justify-content: center;
    font-size: 12px; font-weight: 600; flex-shrink: 0; margin-top: 2px;
  }
  .snum-warn { background: var(--red); color: #fff; }
  .stitle { font-family: var(--serif); font-size: 22px; color: var(--ink); font-weight: 500; line-height: 1.2; }
  .ssub { font-size: 12px; color: var(--ink-soft); margin-top: 4px; }

  /* ── CARDS ── */
  .card { background: var(--white); border: 1px solid var(--surface-2); border-radius: var(--radius-lg); overflow: hidden; box-shadow: var(--shadow); }
  .card-top { background: var(--surface); border-bottom: 1px solid var(--surface-2); padding: 9px 18px; display: flex; align-items: center; justify-content: space-between; gap: 12px; }
  .card-top-label { font-size: 10px; font-weight: 600; letter-spacing: .1em; text-transform: uppercase; color: var(--ink-soft); }
  .card-body { padding: 20px 24px; }

  /* ── COPY BTN ── */
  .copy-btn {
    font-family: var(--mono); font-size: 10px; padding: 4px 12px;
    border-radius: var(--radius-sm); cursor: pointer; border: 1px solid rgba(184,151,58,.4);
    background: rgba(184,151,58,.08); color: var(--gold-dark); transition: all .15s; letter-spacing: .04em;
  }
  .copy-btn:hover { background: rgba(184,151,58,.2); }
  .copy-btn.ok { color: var(--green); border-color: var(--green-border); background: var(--green-soft); }

  /* ── CODE ── */
  .code-wrap { background: #0E0E12; border-radius: var(--radius-lg); overflow: hidden; box-shadow: var(--shadow); }
  .code-bar { background: #161620; padding: 10px 18px; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,.06); }
  .code-file { font-family: var(--mono); font-size: 11px; color: rgba(232,213,160,.7); }
  .copy-btn-dark { font-family: var(--mono); font-size: 10px; padding: 4px 12px; border-radius: var(--radius-sm); cursor: pointer; border: 1px solid rgba(184,151,58,.3); background: rgba(184,151,58,.1); color: var(--gold-light); transition: all .15s; }
  .copy-btn-dark:hover { background: rgba(184,151,58,.2); }
  .copy-btn-dark.ok { color: #7DDFB0; border-color: rgba(109,200,160,.5); background: rgba(15,107,58,.2); }
  pre { font-family: var(--mono); font-size: 11.5px; line-height: 1.75; padding: 20px 24px; overflow-x: auto; color: #CDD6F4; white-space: pre; }

  /* ── ALERTS ── */
  .alert { display: flex; gap: 13px; padding: 13px 16px; border-radius: var(--radius); border-left: 3px solid; margin-bottom: 10px; }
  .alert-icon { font-size: 15px; flex-shrink: 0; margin-top: 1px; }
  .alert-body p { font-size: 13px; line-height: 1.65; color: inherit; }
  .alert-body strong { font-weight: 600; display: block; margin-bottom: 3px; font-size: 13px; }
  .alert-red { background: var(--red-soft); border-color: var(--red); color: #6B1010; }
  .alert-green { background: var(--green-soft); border-color: var(--green); color: #083D20; }
  .alert-gold { background: var(--gold-pale); border-color: var(--gold); color: var(--gold-dark); }
  .alert-blue { background: var(--blue-soft); border-color: var(--blue); color: #0E2060; }

  /* ── GRID ── */
  .g2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .g3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; }
  .g4 { display: grid; grid-template-columns: repeat(4,1fr); gap: 10px; }

  /* ── STAT BOXES ── */
  .stat-box { background: var(--white); border: 1px solid var(--surface-2); border-radius: var(--radius); padding: 14px 16px; text-align: center; box-shadow: var(--shadow); }
  .stat-v { font-family: var(--serif); font-size: 26px; font-weight: 500; color: var(--ink); margin: 0; }
  .stat-l { font-size: 11px; color: var(--ink-soft); margin: 3px 0 0; }

  /* ── META TABLE ── */
  .mt { width: 100%; border-collapse: collapse; font-size: 13px; }
  .mt td { padding: 9px 14px; border-bottom: 1px solid var(--surface-2); vertical-align: top; line-height: 1.55; }
  .mt tr:last-child td { border-bottom: none; }
  .mt td:first-child { font-family: var(--mono); font-size: 11px; color: var(--gold-dark); font-weight: 500; width: 190px; background: var(--surface); white-space: nowrap; }

  /* ── TABS ── */
  .tabs { display: flex; border-bottom: 2px solid var(--surface-2); margin-bottom: 20px; gap: 2px; }
  .tab-btn { padding: 9px 18px; font-size: 12px; font-weight: 500; letter-spacing: .05em; text-transform: uppercase; border: none; background: none; color: var(--ink-soft); cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -2px; transition: all .15s; font-family: var(--sans); }
  .tab-btn.on { color: var(--gold-dark); border-bottom-color: var(--gold); }
  .tab-pane { display: none; }
  .tab-pane.on { display: block; }

  /* ── CHECKLIST ── */
  .checklist { list-style: none; }
  .checklist li { display: flex; align-items: flex-start; gap: 11px; padding: 9px 0; border-bottom: 1px solid var(--surface-2); font-size: 13px; }
  .checklist li:last-child { border-bottom: none; }
  .cbox { width: 20px; height: 20px; border-radius: var(--radius-sm); border: 1.5px solid var(--gold); display: flex; align-items: center; justify-content: center; font-size: 10px; color: var(--gold-dark); font-weight: 600; flex-shrink: 0; margin-top: 1px; }
  .cbox-num { background: var(--ink); border-color: var(--ink); color: var(--gold-light); font-family: var(--mono); font-size: 9px; }

  /* ── BLOG PREVIEW ── */
  .browser { background: var(--white); border: 1px solid var(--surface-2); border-radius: var(--radius-lg); overflow: hidden; box-shadow: var(--shadow); }
  .browser-bar { background: #F0EDE6; height: 38px; display: flex; align-items: center; padding: 0 14px; gap: 7px; border-bottom: 1px solid var(--surface-2); }
  .bdot { width: 10px; height: 10px; border-radius: 50%; }
  .bd-r{background:#FF5F57;}.bd-y{background:#FEBC2E;}.bd-g{background:#28C840;}
  .burl { background: var(--white); flex: 1; margin-left: 8px; height: 22px; border-radius: var(--radius-sm); display: flex; align-items: center; padding: 0 10px; font-family: var(--mono); font-size: 10px; color: var(--ink-ghost); border: 1px solid var(--surface-2); }
  .blog-scroll { max-height: 560px; overflow-y: auto; padding: 44px 52px; }
  .blog-eyebrow { font-size: 11px; letter-spacing: .12em; text-transform: uppercase; color: var(--gold-dark); font-weight: 500; margin-bottom: 12px; }
  .blog-h1 { font-family: var(--serif); font-size: 32px; line-height: 1.2; color: var(--ink); margin-bottom: 18px; font-weight: 600; }
  .blog-byline { display: flex; gap: 16px; align-items: center; flex-wrap: wrap; font-size: 12px; color: var(--ink-soft); padding-bottom: 20px; border-bottom: 1px solid var(--surface-2); margin-bottom: 24px; }
  .blog-byline-chip { background: var(--gold-pale); color: var(--gold-dark); border: 1px solid var(--gold-light); padding: 2px 9px; border-radius: 20px; font-size: 10px; font-weight: 500; }
  .policy-box { background: linear-gradient(135deg, var(--gold-pale), #F5EDCF); border: 1px solid var(--gold-light); border-left: 4px solid var(--gold); border-radius: var(--radius); padding: 16px 18px; margin: 20px 0; }
  .policy-box-title { font-size: 11px; font-weight: 600; letter-spacing: .08em; text-transform: uppercase; color: var(--gold-dark); margin-bottom: 8px; }
  .policy-box-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .policy-col h4 { font-size: 11px; font-weight: 600; color: var(--ink-soft); margin-bottom: 6px; text-transform: uppercase; letter-spacing: .06em; }
  .policy-old { background: var(--red-soft); border: 1px solid var(--red-border); border-radius: var(--radius-sm); padding: 10px 12px; }
  .policy-new { background: var(--green-soft); border: 1px solid var(--green-border); border-radius: var(--radius-sm); padding: 10px 12px; }
  .policy-col p { font-size: 12px; line-height: 1.6; color: var(--ink-mid); margin: 0; }
  .blog-h2 { font-family: var(--serif); font-size: 22px; font-weight: 600; color: var(--ink); margin: 32px 0 10px; }
  .blog-h3 { font-size: 15px; font-weight: 600; color: var(--ink); margin: 20px 0 8px; }
  .blog-p { font-size: 14px; line-height: 1.85; color: var(--ink-mid); margin-bottom: 14px; }
  .stat-pull { background: var(--surface); border-left: 3px solid var(--gold); padding: 12px 16px; border-radius: 0 var(--radius-sm) var(--radius-sm) 0; margin: 18px 0; }
  .stat-pull p { font-size: 14px; font-weight: 500; color: var(--gold-dark); margin: 0; }
  .stat-pull span { font-size: 11px; color: var(--ink-soft); display: block; margin-top: 3px; font-weight: 400; }
  .steps-list { counter-reset: steps; list-style: none; margin: 14px 0; }
  .steps-list li { counter-increment: steps; display: flex; gap: 14px; padding: 12px 0; border-bottom: 1px solid var(--surface-2); font-size: 14px; color: var(--ink-mid); line-height: 1.65; }
  .steps-list li:last-child { border-bottom: none; }
  .steps-list li::before { content: counter(steps); min-width: 26px; height: 26px; background: var(--ink); color: var(--gold-light); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 600; flex-shrink: 0; font-family: var(--mono); margin-top: 1px; }
  .faq-wrap { border: 1px solid var(--surface-2); border-radius: var(--radius); overflow: hidden; margin: 14px 0; }
  .faq-item { border-bottom: 1px solid var(--surface-2); padding: 14px 18px; }
  .faq-item:last-child { border-bottom: none; }
  .faq-q { font-size: 14px; font-weight: 500; color: var(--ink); margin-bottom: 6px; }
  .faq-a { font-size: 13px; color: var(--ink-soft); line-height: 1.7; }
  .visa-table { width: 100%; border-collapse: collapse; font-size: 13px; margin: 14px 0; }
  .visa-table th { background: var(--ink); color: var(--gold-light); padding: 9px 14px; text-align: left; font-size: 10px; letter-spacing: .08em; text-transform: uppercase; font-weight: 500; }
  .visa-table td { padding: 9px 14px; border-bottom: 1px solid var(--surface-2); color: var(--ink-mid); vertical-align: top; }
  .visa-table tr:last-child td { border-bottom: none; }
  .visa-table tr:hover td { background: var(--surface); }
  .blog-cta { background: var(--ink); border-radius: var(--radius); padding: 28px 30px; margin-top: 32px; position: relative; overflow: hidden; }
  .blog-cta::before { content: ''; position: absolute; top: -40px; right: -40px; width: 180px; height: 180px; background: radial-gradient(circle, rgba(184,151,58,.18), transparent 70%); border-radius: 50%; pointer-events: none; }
  .blog-cta h3 { font-family: var(--serif); font-size: 24px; color: var(--gold-light); margin-bottom: 8px; font-weight: 500; font-style: italic; }
  .blog-cta p { font-size: 13px; color: rgba(255,255,255,.6); line-height: 1.7; margin-bottom: 16px; }
  .cta-btn { display: inline-block; background: var(--gold); color: var(--ink); padding: 11px 24px; border-radius: var(--radius-sm); font-size: 13px; font-weight: 600; text-decoration: none; letter-spacing: .03em; }
  .cta-btn:hover { background: var(--gold-light); }

  /* ── TOOL LINKS ── */
  .tool-link { display: flex; align-items: flex-start; gap: 10px; padding: 10px 14px; background: var(--surface); border-radius: var(--radius-sm); margin-bottom: 8px; border: 1px solid var(--surface-2); }
  .tool-link code { font-family: var(--mono); font-size: 11px; color: var(--blue); background: var(--blue-soft); padding: 2px 7px; border-radius: 3px; flex-shrink: 0; margin-top: 2px; }
  .tool-link p { font-size: 12px; color: var(--ink-soft); line-height: 1.55; margin: 0; }


  @media(max-width:760px){
    .page{padding:0 20px 60px}
    .hero{padding:36px 20px 32px}
    .topbar{padding:0 20px}
    .g2,.g3,.g4{grid-template-columns:1fr}
    .blog-scroll{padding:28px 24px}
    .blog-h1{font-size:24px}
    .policy-box-grid{grid-template-columns:1fr}
  }
  @media print {
    .topbar{display:none}
    .code-wrap{border:1px solid #ddd}
    pre{font-size:10px}
    .blog-scroll{max-height:none}
  }
</style>
        <div class="">
         

          <p class="blog-p">For seventeen years, a single number stood between millions of aspiring Dubai residents and the city's property investor visa: AED 750,000. If your chosen apartment fell below that threshold — and hundreds of perfectly good studios and one-bedrooms across JVC, International City, and Dubai South did — you were locked out of the residency programme entirely, regardless of your income, stability, or commitment to the market.</p>
          <p class="blog-p">That number is gone. On 1 May 2026, the Dubai Land Department confirmed one of the most significant policy changes to its residency-linked property programme since 2009. This guide explains exactly what changed, who benefits, how to apply, and — if you have been waiting for a reason to buy in Dubai — why acting now with a zero-commission broker could save you both the visa barrier and tens of thousands of dirhams in broker fees.</p>

          <div class="policy-box">
            <p class="policy-box-title">What changed on 1 May 2026 — before vs after</p>
            <div class="policy-box-grid">
              <div class="policy-col">
                <h4>Before (2009–April 2026)</h4>
                <div class="policy-old">
                  <p>Minimum property value of AED 750,000 required for the 2-year investor visa. Studios and entry-level apartments in JVC, Dubailand, International City — all excluded. Locked out roughly 24% of ready-home buyers in Q1 2026.</p>
                </div>
              </div>
              <div class="policy-col">
                <h4>After (1 May 2026 — now)</h4>
                <div class="policy-new">
                  <p>No minimum for sole owners. Any fully owned, completed residential property with a DLD title deed qualifies — regardless of price. Joint owners: AED 400,000 per person. 10-year Golden Visa minimum (AED 2M) unchanged.</p>
                </div>
              </div>
            </div>
          </div>

          <h2 class="blog-h2">Why this matters most to Indian NRI buyers</h2>
          <div class="stat-pull">
            <p>Indians account for 22% of all Dubai residential deals — the largest single nationality of buyers in 2025.</p>
            <span>Source: Dubai Land Department, Annual Report 2025</span>
          </div>
          <p class="blog-p">The previous threshold was effectively a class barrier. A salaried professional in Bengaluru or Delhi earning well and looking to buy a AED 550,000 studio in JVC as a first overseas investment could not access the residency that would make that investment practical. They would own the property, but could not live in it on an investor visa. That meant relying on an employer for UAE residency — which disappears the moment you change jobs.</p>
          <p class="blog-p">CBRE India's head of research Abhinav Joshi confirmed what many suspected: the update will drive significantly higher demand from first-time international investors, mid-income professionals, and younger Indian investors who felt excluded from the property visa system. A AED 450,000–600,000 apartment — well within reach for an Indian professional with savings — now qualifies for a 2-year renewable UAE residency that is entirely independent of any employer.</p>
          <p class="blog-p">At Nova Capital, we offer zero brokerage on every property we sell. For an NRI buying a AED 550,000 studio, that is a saving of AED 27,500 in broker fees — money that goes directly into your down payment or furnishing budget instead.</p>

          <h2 class="blog-h2">The three Dubai property visa types in 2026</h2>
          <table class="visa-table">
            <thead><tr><th>Visa type</th><th>Minimum property value</th><th>Duration</th><th>Best for</th></tr></thead>
            <tbody>
              <tr><td><strong>2-year investor visa</strong><br><span style="font-size:11px;color:#5C5C66">(Taskeen programme)</span></td><td style="color:#0F6B3A;font-weight:500">No minimum for sole owners<br><span style="font-size:11px;color:#5C5C66">AED 400K/person for joint</span></td><td>2 years, renewable</td><td>First-time investors, NRI buyers, mid-market properties</td></tr>
              <tr><td><strong>5-year retirement visa</strong></td><td>AED 2 million property + savings/income</td><td>5 years, renewable</td><td>Retirees aged 55+</td></tr>
              <tr><td><strong>10-year Golden Visa</strong></td><td>AED 2 million (unchanged)</td><td>10 years, renewable</td><td>HNI investors, long-term residents</td></tr>
            </tbody>
          </table>

          <h2 class="blog-h2">Which properties now qualify — and the best communities under AED 750,000</h2>
          <p class="blog-p">Properties that previously fell below the threshold and now fully qualify for the 2-year investor visa include completed studios and one-bedroom apartments across some of Dubai's best-yielding communities. Properties registered under Oqood (off-plan) do not qualify — you need a completed title deed.</p>
          <h3 class="blog-h3">Jumeirah Village Circle (JVC) — entry from AED 480,000</h3>
          <p class="blog-p">JVC consistently delivers some of Dubai's highest rental yields at 7.2% on average (CBRE UAE, 2024). Studios start from AED 480,000, one-beds from AED 650,000. The community recorded over 12,400 transactions in 2024, making it the most liquid mid-market community in Dubai. A studio buyer at AED 500,000 previously had no visa pathway. Now they have a 2-year residency, a rental income stream, and a property in a community where prices grew 8.9% year-on-year in Q1 2026. View Nova Capital's <a href="/new-projects" style="color:var(--gold-dark);font-weight:500">current JVC listings — zero commission</a>.</p>
          <h3 class="blog-h3">Dubai South / Expo City — entry from AED 430,000</h3>
          <p class="blog-p">Dubai South is the long-term structural play. Al Maktoum Airport — set to become the world's largest when fully operational — sits at its centre. Connectivity to the upcoming Dubai Metro Blue Line is already driving renewed buyer interest (Gulf News, 2026). Studios start from AED 430,000. For investors with a 5–7 year horizon, this is arguably the most compelling entry-level market in the UAE right now. Explore our <a href="/new-projects" style="color:var(--gold-dark);font-weight:500">off-plan projects in Dubai South</a> with 10% deposit payment plans.</p>
          <h3 class="blog-h3">International City — entry from AED 320,000</h3>
          <p class="blog-p">The most affordable freehold community in Dubai. Studios from AED 320,000. High rental yields driven by a large workforce tenant base. Less glamorous than JVC but a genuine income-producing asset for budget-conscious first-time NRI investors who want UAE residency at the lowest possible entry cost.</p>

          <h2 class="blog-h2">How to apply: step-by-step process</h2>
          <ol class="steps-list">
            <li><strong>Buy a completed property</strong> with a registered DLD title deed. Off-plan (Oqood only) does not yet qualify. For sole owners, any price. For joint owners, AED 400,000 minimum per person.</li>
            <li><strong>Register with the Dubai Land Department.</strong> All transactions go through the DLD's Cube platform. Nova Capital handles the full registration process on your behalf — at zero commission.</li>
            <li><strong>Apply for the visa via DLD Cube.</strong> Visit dldcube.com or use the official DLD investor visa portal (dubailand.gov.ae). Upload title deed, passport, Emirates ID photo, and no-objection certificate from your bank if mortgaged.</li>
            <li><strong>Medical test and Emirates ID.</strong> After visa issuance, complete the standard medical test and biometrics at a UAE health authority centre to receive your Emirates ID — essential for opening bank accounts and obtaining a UAE driving licence.</li>
            <li><strong>Sponsor your family.</strong> The 2-year investor visa allows you to sponsor a spouse and children, giving your whole family UAE residency through a single property purchase.</li>
          </ol>
          <div class="stat-pull">
            <p>Properties below AED 750,000 made up 24% of all ready home transactions in Dubai in Q1 2026 — a segment now fully unlocked for residency-motivated buyers.</p>
            <span>Source: Savills Middle East, Q1 2026 Dubai Residential Analysis</span>
          </div>

          <h2 class="blog-h2">What this means for Dubai's property market</h2>
          <p class="blog-p">The timing is deliberate. Dubai's property market absorbed a geopolitical shock in early 2026, with buyer enquiries dropping 45% in the immediate aftermath of regional tensions. By removing the visa entry barrier, the DLD is aggressively targeting a different demographic: the salaried professional and the upper-middle-class Indian investor who had been pushed toward Mumbai and Bengaluru by the previous threshold.</p>
          <p class="blog-p">Analysts at Savills Middle East confirmed the update will drive significantly higher demand from first-time international investors — particularly from India, the UK, and Southeast Asia. Entire segments of Dubai's property market that were previously invisible to visa-motivated buyers are now fully in play. JVC, Remraam, Dubai South, International City — communities that delivered 12.4% price growth in Q1 2026 even during the conflict period (DLD) — are where this demand will land first.</p>

          <h2 class="blog-h2">Frequently asked questions</h2>
          <div class="faq-wrap">
            <div class="faq-item">
              <p class="faq-q">Has Dubai removed the minimum property value for the investor visa?</p>
              <p class="faq-a">Yes. The Dubai Land Department confirmed on 1 May 2026 that sole property owners no longer need to meet a minimum AED 750,000 property value to qualify for the 2-year Property Investor Visa. Any fully owned, completed residential property now qualifies regardless of price.</p>
            </div>
            <div class="faq-item">
              <p class="faq-q">Can an Indian NRI buy a studio in JVC and get a Dubai investor visa?</p>
              <p class="faq-a">Yes — as of May 2026. A studio in JVC starting from AED 480,000, bought as the sole registered owner, now qualifies for a 2-year renewable UAE residency visa through DLD Cube. You can also sponsor your spouse and children on this visa. Nova Capital's zero-commission model means no broker fees on the purchase.</p>
            </div>
            <div class="faq-item">
              <p class="faq-q">What is the minimum for joint owners?</p>
              <p class="faq-a">AED 400,000 per person. If a couple buys a property together, each person's share must be worth at least AED 400,000 — so the minimum property value for a couple is AED 800,000. This rule prevents visa-pooling through shared low-value assets.</p>
            </div>
            <div class="faq-item">
              <p class="faq-q">Does the Golden Visa still require AED 2 million?</p>
              <p class="faq-a">Yes — the 10-year Golden Visa threshold is unchanged at AED 2 million. The May 2026 rule change only affects the 2-year Property Investor Visa (Taskeen programme).</p>
            </div>
            <div class="faq-item">
              <p class="faq-q">Does an off-plan property qualify?</p>
              <p class="faq-a">No. The 2-year investor visa requires a completed property with a registered DLD title deed. Off-plan properties registered under Oqood do not qualify until completion and title deed issuance. However, off-plan buyers can apply once handover occurs — Nova Capital will guide you through the full process.</p>
            </div>
          </div>
        </div>
     
    </div>
  `
};